import {
  getProductList,
  pathCreateProduct,
  pathDeleteProduct,
  postImportProduct,
  postImportCategory,
  getProductsListPromotion,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { productActions } from "../reducers/product";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchProductList = (id_product = 0) => {
  return (dispatch) => {
    return apiService
      .get(getProductList(id_product))
      .then((response) => {
        id_product == 0
          ? dispatch(productActions.fetchProductList(response.data))
          : dispatch(productActions.fetchProductDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchProductListPromotion = (id_country) => {
  return (dispatch) => {
    return apiService
      .get(getProductsListPromotion(id_country))
      .then((response) => {
        dispatch(productActions.fetchProductList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchImportProducts = (formData, selectedOption) => {
  const url =
    selectedOption == "product" ? postImportProduct() : postImportCategory();
  return (dispatch) => {
    return apiService
      .postMultipart(url, formData)
      .then((response) => {
        if (selectedOption == "product") {
          dispatch(fetchProductList(0));
          toast.success(t("productListActions.importProducts"), {
            theme: "colored",
          });
        } else {
          toast.success(t("productListActions.importCategories"), {
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const clearProductDetail = () => {
  return (dispatch) => {
    dispatch(productActions.fetchProductDetail([]));
  };
};

export const createNewProduct = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateProduct(), data)
      .then((response) => {
        // dispatch(productActions.fetchProductList(response.data));
        toast.success(t("productListActions.created"), {
          theme: "colored",
        });
        navigate("/product-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditProduct = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCreateProduct(), data)
      .then((response) => {
        // dispatch(productActions.fetchProductList(response.data));
        toast.success(t("productListActions.updated"), {
          theme: "colored",
        });
        navigate("/product-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteProduct = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteProduct(id))
      .then((response) => {
        toast.success(t("productListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchProductList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
